module.exports = __webpack_public_path__ + "img/role01.86aa94e6.png";